export default {
      id: "check-usage",
      viewBox: "0 0 14 11",
      url: __webpack_public_path__ + "img/icons.svg#check",
      toString: function () {
        return this.url;
      }
    }